<script src="../../../../../retailstore365_server/model/report.js"></script>
<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">


        <el-row>
            <el-col :span="24" :class="$style.body" class="subjectList">


                <el-form ref="form" label-width="80px">
                    <div :class="$style.wrap">
                        <el-form-item label="所属区域" prop="area">
                            <el-select v-model="region" clearable
                                       placeholder="选择区域" size="small" style="width: 230px;">
                                <el-option v-for="item in regionArray" :key="item.region_id"
                                           :label="item.region_name"
                                           :value="item.region_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省份" prop="provinces">
                            <el-select v-model="provinces" v-on:change="handleProvincesClick" clearable
                                       placeholder="选择省份" size="small" style="width: 230px;">
                                <el-option v-for="item in provinceArray" :key="item.province_id"
                                           :label="item.province_name"
                                           :value="item.province_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市" prop="city">
                            <el-select v-model="city" clearable placeholder="选择城市" :disabled="isShowCity"
                                       size="small"
                                       style="width: 230px;">
                                <el-option v-for="item in selectCityArray" :key="item.city_id"
                                           :label="item.city_name"
                                           :value="item.city_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>


                <el-row>
                    <el-button type="success" size="mini" @click.stop="handleQueryClick">查询</el-button>
                    <el-button type="danger" size="mini" @click.stop="handleResetClick">重置</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-upload2" style="float: right"
                    @click.stop="handleExportData">导出数据
                    </el-button>
                </el-row>

                <div :class="$style.border"></div>

                <div :class="$style.footer">
                    <div style="width: 100%">
                        <el-button-group :class="$style.month" class="a_modal">
                            <el-button size="small" icon="el-icon-arrow-left"
                                       @click.stop="lastNextMonthClick(-1)"></el-button>
                            <el-button size="small" disabled>{{dateStr}}</el-button>
                            <el-button size="small" icon="el-icon-arrow-right"
                                       @click.stop="lastNextMonthClick(1)"></el-button>
                        </el-button-group>
                    </div>

                    <div style="width: 100%">
                        <el-row>
                            <el-col :span="8">
                                <div align="center">
                                    <div style="height: 200px" ref="areaEchart"></div>
                                    <span style="color: #4A90E2;font-size: 14px">区域销售占比</span></div>

                                <!--<hr style="margin-top:20px;margin-bottom:20px;background-color: #DEDEDE;height: 160px;width: 2px;display: flex;-->
                                <!--justify-content: flex-end;"  />-->
                            </el-col>
                            <el-col :span="8" align="center">
                                <div style="height: 200px" ref="categoryEchart">
                                </div>
                                <span style="color: #4A90E2;font-size: 14px">品类销售占比</span>
                            </el-col>
                            <el-col :span="8" align="center">
                                <div style="height: 200px" ref="storesEchart">
                                </div>
                                <span style="color: #4A90E2;font-size: 14px">门店贡献比</span>
                            </el-col>
                        </el-row>
                    </div>

                    <div style="width: 100%;margin-top: 20px">

                        <el-row style="margin-bottom: 15px;margin-top: 5px">
                            <el-col :span="24" :class="$style.text">
                                <div class="grid-content bg-purple" align="center">

                                    <span>平均日销:</span>
                                    <span style="color: #4A90E2">{{resultInfo.avgamount}}</span>
                                    <span :class="$style.span">元</span>

                                    <span>客单价:</span>
                                    <span style="color: #4A90E2">{{resultInfo.avgper_customer}}</span>
                                    <span :class="$style.span">元</span>

                                    <span>成交笔数:</span>
                                    <span style="color: #4A90E2">{{resultInfo.avgdeals}}</span>
                                    <span :class="$style.span">笔</span>

                                    <span>坪效:</span>
                                    <span style="color: #4A90E2">{{resultInfo.avgarea_effectiveness}}</span>
                                    <span :class="$style.span">元/平</span>

                                    <span>人效:</span>
                                    <span style="color: #4A90E2">{{resultInfo.avgclerk_effectiveness}}</span>
                                    <span :class="$style.span">元/人</span>

                                    <span>销售指标:</span>
                                    <span style="color: #4A90E2">{{resultInfo.target}}</span>
                                    <span :class="$style.span">元</span>

                                    <span>实际销售:</span>
                                    <span style="color: #4A90E2">{{resultInfo.amount}}</span>
                                    <span :class="$style.span">元</span>

                                    <span>达成率:</span>
                                    <span style="color: #4A90E2">{{resultInfo.yield_rate}}</span>
                                    <span :class="$style.span">%</span>

                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-table
                            :data="tableData"
                            @cell-click="cellClick"
                            style="width: 100%"
                            :header-cell-style="tableHeaderColor">

                        <el-table-column
                                align="right"
                                min-width="30px">
                            <template slot-scope="scope">

                                <img width="6px" height="10px"
                                     :src="arrow_icon">
                            </template>
                        </el-table-column>

                        <el-table-column
                                label="区域"
                                prop="area"
                                width="70">
                        </el-table-column>
                        <el-table-column
                                label="省份"
                                prop="province"
                                sortable
                                width="70">
                        </el-table-column>
                        <el-table-column
                                label="城市"
                                prop="city"
                                sortable
                                width="70">
                        </el-table-column>
                        <el-table-column
                                label="门店"
                                prop="store_name"
                                sortable
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                label="日销"
                                prop="avgamount"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="客单价"
                                prop="avgper_customer"
                                sortable
                                align="center"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                label="成交笔数"
                                prop="avgdeals"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="坪效"
                                prop="avgarea_effectiveness"
                                sortable
                                align="center"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="人效"
                                prop="avgclerk_effectiveness"
                                sortable
                                align="center"
                                width="70">
                        </el-table-column>
                        <el-table-column
                                label="指标"
                                prop="target"
                                sortable
                                align="center"
                                width="70">
                        </el-table-column>
                        <el-table-column
                                label="实际"
                                prop="amount"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="达成率"
                                prop="yield_rate"
                                sortable
                                align="center"
                                width="90">
                        </el-table-column>

                    </el-table>

                </div>
            </el-col>
        </el-row>

        <el-dialog
                :visible.sync="showModalMonth" :show-close="false"
                width="75%" :class="$style.modal"
                :before-close="closeModal">
            <div slot="title" :class="$style.title">
                <span>门店销售明细</span>
                <div>
                    <el-button type="danger" size="small" @click.stop="closeModal">关闭</el-button>
                </div>
            </div>
            <div style="width: 100%;margin-top: -20px" align="center">

                <el-row>
                    <el-col :span="8">
                        <div align="left">
                        <el-button-group>
                            <el-button size="mini" icon="el-icon-arrow-left"
                                       @click.stop="lastNextMonthClickByday(-1)"></el-button>
                            <el-button size="mini" disabled>{{salesDetailByDay.dateStrByDay}}</el-button>
                            <el-button size="mini" icon="el-icon-arrow-right"
                                       @click.stop="lastNextMonthClickByday(1)"></el-button>
                        </el-button-group>
                        </div>
                    </el-col>
                    <el-col :span="8"><div align="center" style="color: #FF9901;font-size: 18px">{{salesDetailByDay.storeName}}</div></el-col>
                    <el-col :span="8"><div align="right">
                        <el-radio-group fill="#FF9901" v-model="salesDetailByDay.tabPosition" :class="$style.grop" size="mini" @change="changeRadio">
                        <el-radio-button label="day">按日期</el-radio-button>
                        <el-radio-button label="clerk">按店员</el-radio-button>
                    </el-radio-group></div></el-col>
                </el-row>


                <div style="width: 100%;margin-top: 20px">

                    <el-row style="margin-bottom: 15px;margin-top: 5px">
                        <el-col :span="24" :class="$style.text">
                            <div class="grid-content bg-purple" align="center">

                                <span>平均日销:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.avgamount}}</span>
                                <span :class="$style.span">元</span>

                                <span>客单价:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.avgper_customer}}</span>
                                <span :class="$style.span">元</span>

                                <span>成交笔数:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.avgdeals}}</span>
                                <span :class="$style.span">笔</span>

                                <span>坪效:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.avgarea_effectiveness}}</span>
                                <span :class="$style.span">元/平</span>

                                <span>人效:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.avgclerk_effectiveness}}</span>
                                <span :class="$style.span">元/人</span>

                                <span>销售指标:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.target}}</span>
                                <span :class="$style.span">元</span>

                                <span>实际销售:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.amount}}</span>
                                <span :class="$style.span">元</span>

                                <span>达成率:</span>
                                <span style="color: #4A90E2">{{salesDetailByDay.resultInfo.yield_rate}}</span>
                                <span :class="$style.span">%</span>

                            </div>
                        </el-col>
                    </el-row>
                </div>
                <el-table
                        :data="salesDetailByDay.tableDayData"
                        style="width: 100%"
                        :header-cell-style="tableHeaderColor"
                        v-show="salesDetailByDay.tabPosition === 'day'">

                    <el-table-column
                            label="日期"
                            prop="day"
                            min-width="120">
                    </el-table-column>

                    <el-table-column
                            label="日销"
                            prop="avgamount"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="客单价"
                            prop="avgper_customer"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="成交笔数"
                            prop="avgdeals"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="坪效"
                            prop="avgarea_effectiveness"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="人效"
                            prop="avgclerk_effectiveness"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="指标"
                            prop="target"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="实际"
                            prop="amount"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="达成率"
                            prop="yield_rate"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>

                </el-table>

                <el-table
                        :data="salesDetailByDay.tableCLerkData"
                        style="width: 100%"
                        :header-cell-style="tableHeaderColor"
                        v-show="salesDetailByDay.tabPosition === 'clerk'">

                    <el-table-column
                            label="店员"
                            prop="clerk_name"
                            min-width="120">
                    </el-table-column>

                    <el-table-column
                            label="日销"
                            prop="avgamount"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="客单价"
                            prop="avgper_customer"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="成交笔数"
                            prop="avgdeals"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="指标"
                            prop="target"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="实际"
                            prop="amount"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>
                    <el-table-column
                            label="达成率"
                            prop="yield_rate"
                            sortable
                            align="center"
                            min-width="60">
                    </el-table-column>

                </el-table>
            </div>

        </el-dialog>

        <el-dialog
                title="导出数据"
                :visible.sync="dialogVisible"
                width="35%"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div class="b_modal">
                <el-button type="primary" @click.stop="handleExportDataByStore">门店汇总</el-button>

                <!--<el-button type="primary" @click.stop="handleExportDataByDay">按日期</el-button>-->

                <!--<el-button type="primary" @click.stop="handleExportDataByClerk">按店员</el-button>-->
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import http from '../../../APIService/http'
    import moment from 'moment'
    import echarts from 'echarts'
    import Arrow from '../../../assets/images/enter_icon.png'

    export default {
        data() {
            return {
                loading: false,
                dialogVisible: false,
                arrow_icon: Arrow,

                regionArray: [],
                provinceArray: [],
                cityArray: [],
                selectCityArray: [],

                areaArray: [],
                categoryArray: [],
                storesArray: [],

                region: '',
                provinces: '',
                city: '',
                id: '',
                date: moment(),

                dateStr: this.getCurrentDate(),
                tableData: [],
                resultInfo: {
                    amount: 0,
                    avgamount: 0,
                    avgdeals: 0,
                    avgarea_effectiveness: 0,
                    avgclerk_effectiveness: 0,
                    avgper_customer: 0,
                    target: 0,
                    yield_rate: 'N/A'
                },

                showModalMonth: false,
                salesDetailByDay:{
                    storeName:'333',
                    store_id:'',
                    dateByDay: moment(),
                    dateStrByDay:this.getCurrentDate(),
                    tabPosition: 'day',
                    resultInfo: {
                        amount: 0,
                        avgamount: 0,
                        avgdeals: 0,
                        avgarea_effectiveness: 0,
                        avgclerk_effectiveness: 0,
                        avgper_customer: 0,
                        target: 0,
                        yield_rate: 'N/A'
                    },
                    tableDayData:[],
                    tableCLerkData:[]
                }
            }
        },
        components: {},
        computed: {
            isShowCity() {
                if (this.provinces.length > 0) {
                    return false
                }
                return true
            },
        },
        created() {

            let obj = this.$store.getters.getStore
            this.title = obj.storeName

            this.id = this.$store.getters.getStore.id
            this.getAreaCity()

            this.getSalesAccounted()
            this.getSalesStatisticalData()

        },
        methods: {

            //各占比
            async getSalesAccounted() {
                try {

                    this.loading = true
                    let data = {
                        region: this.region,
                        provinces: this.provinces,
                        city: this.city,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        month: this.date.format("YYYY-MM"),
                    }


                    await http.post('/wapi/v1/getSalesAccounted', data).then(res => {

                        let data = res.data

                        this.areaArray = data.areaArray
                        this.categoryArray = data.categoryArray
                        this.storesArray = data.storesArray

                        this.loading = false


                        this.initChart()

                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 初始化页面获取数据
            async getSalesStatisticalData() {
                try {

                    // this.loading = true
                    let data = {
                        region: this.region,
                        provinces: this.provinces,
                        city: this.city,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        month: this.date.format("YYYY-MM"),
                    }


                    await http.post('/wapi/v1/getSalesStatisticalData', data).then(res => {


                        let data = res.data

                        this.resultInfo = res.data.resultInfo
                        this.tableData = data.result

                        // this.loading = false


                        this.initChart()

                    })
                } catch (err) {
                    // this.loading = false
                    this.error()
                }
            },
            async getAreaCity() {

                try {

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    await http.post('/wapi/v1/getAreaCity', data).then(res => {

                        this.regionArray = res.data.regionArray
                        this.provinceArray = res.data.provinceArray
                        this.cityArray = res.data.cityArray


                    })

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },

            // 省份的改变
            handleProvincesClick() {
                this.city = ''
                this.selectCityArray = []
                this.cityArray.forEach(item => {
                    if (item.province_id === this.provinces) {
                        this.selectCityArray.push(item)
                    }
                })
            },
            // 查询
            handleQueryClick() {
                this.getSalesAccounted()
                this.getSalesStatisticalData()
            },
            // 重置
            handleResetClick() {
                this.region = '',
                    this.provinces = '',
                    this.city = ''
            },
            // 修改table header的背景色
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #E0E0E0;color: #5C575E;font-size: 13px';
                }
            },
            getCurrentDate() {

                let date = moment(this.date)
                return date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'


            },
            lastNextMonthClick(num) {

                let currentDate = moment(this.date)
                let date = currentDate.add(num, "months")
                this.date = date
                this.dateStr = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                this.getSalesAccounted()
                this.getSalesStatisticalData()

            },
            lastNextMonthClickByday(num) {

                let currentDate = moment(this.salesDetailByDay.dateByDay)
                let date = currentDate.add(num, "months")
                this.salesDetailByDay.dateByDay = date
                this.salesDetailByDay.dateStrByDay = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                if(this.salesDetailByDay.tabPosition === 'day'){
                    this.getSalesDetailByDay()
                }else {
                    this.getSalesDetailByClerk()
                }

            },
            getFormatDate(arg) {

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },

            handleExportData() {
                // this.dialogVisible = true
                this.handleExportDataByStore()
            },
            initChart() {
                this.areaEchart = echarts.init(this.$refs.areaEchart)
                this.categoryEchart = echarts.init(this.$refs.categoryEchart)
                this.storesEchart = echarts.init(this.$refs.storesEchart)

                   let colors= ['#50E3C2', '#63A9FA','#D16366','#C566D8','#FF9901','#ED3B3F','#6BC235','#F9B4B4','#FECFA3']
                // 把配置和数据放这里
                this.areaEchart.setOption({
                    // tooltip: {
                    //     trigger: 'axis',
                    //     axisPointer: {
                    //         type: 'cross',
                    //         crossStyle: {
                    //             color: '#999'
                    //         }
                    //     }
                    // },
                    // title : {
                    //     text: '某站点用户访问来源',
                    //     subtext: '纯属虚构',
                    //     x:'center'
                    // },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: {d}% ({c}万元)"
                    },
                    // legend: {
                    //     orient: 'vertical',
                    //     left: 'left',
                    //     data: ['直接访问','邮件营销','联盟广告','视频广告','搜索引擎']
                    // },
                    color:colors,
                    series: [
                        {
                            name: '区域销售占比',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '55%'],
                            data: this.areaArray,
                            label: {
                                formatter: '{b|{b}:}{per|{d}%}\n({c}万元)',
                                rich: {
                                    b: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    per: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    c: {
                                        color: '#B2B4B9',
                                        align: 'center'
                                    }
                                }
                            },
                            itemStyle: {

                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                        }],

                })
                this.categoryEchart.setOption({
                    // tooltip: {
                    //     trigger: 'axis',
                    //     axisPointer: {
                    //         type: 'cross',
                    //         crossStyle: {
                    //             color: '#999'
                    //         }
                    //     }
                    // },
                    // title : {
                    //     text: '某站点用户访问来源',
                    //     subtext: '纯属虚构',
                    //     x:'center'
                    // },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: {d}% ({c}万元)"
                    },
                    // legend: {
                    //     orient: 'vertical',
                    //     left: 'left',
                    //     data: ['直接访问','邮件营销','联盟广告','视频广告','搜索引擎']
                    // },
                    color:colors,
                    series: [
                        {
                            name: '品类销售占比',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '55%'],

                            data: this.categoryArray,
                            label: {
                                formatter: '{b|{b}:}{per|{d}%}\n({c}万元)',
                                rich: {
                                    b: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    per: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    c: {
                                        color: '#B2B4B9',
                                        align: 'center'
                                    }
                                }
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                        }],

                })
                this.storesEchart.setOption({
                    // tooltip: {
                    //     trigger: 'axis',
                    //     axisPointer: {
                    //         type: 'cross',
                    //         crossStyle: {
                    //             color: '#999'
                    //         }
                    //     }
                    // },
                    // title : {
                    //     text: '某站点用户访问来源',
                    //     subtext: '纯属虚构',
                    //     x:'center'
                    // },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: {d}% ({c}万元)"
                    },
                    // legend: {
                    //     orient: 'vertical',
                    //     left: 'left',
                    //     data: ['直接访问','邮件营销','联盟广告','视频广告','搜索引擎']
                    // },
                    color:colors,
                    series: [
                        {
                            name: '门店贡献比',
                            type: 'pie',
                            radius: '55%',
                            center: ['45%', '55%'],
                            data: this.storesArray,
                            label: {
                                formatter: '{b|{b}:}{per|{d}%}\n({c}万元)',
                                rich: {
                                    b: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    per: {
                                        fontSize:12,
                                        color: '#FECFA3',
                                        align: 'center'
                                    },
                                    c: {
                                        color: '#B2B4B9',
                                        align: 'center'
                                    }
                                }
                            },
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                        }],

                })
                window.onresize = this.areaEchart.resize;
                window.onresize = this.categoryEchart.resize;
                window.onresize = this.storesEchart.resize;


            },
            async handleExportDataByStore() {//门店汇总
                try {
                    this.loading = true

                    //工时统计表
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['区域', '省份', '城市', '门店', '日销', '客单价', '成交笔数', '坪效', '人效', '指标', '实际', '达成率']
                        const filterVal = ['area', 'province', 'city', 'store_name', 'avgamount', 'avgper_customer', 'avgdeals', 'avgarea_effectiveness', 'avgclerk_effectiveness', 'target', 'amount', 'yield_rate']
                        const list = this.tableData
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '销售统计(门店汇总)',
                            autoWidth: this.autoWidth
                        })

                    })


                    this.loading = false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // async handleExportDataByDay() {//销售统计(按日期)
            //     try {
            //         this.loading = true
            //
            //         //店员工时统计表
            //         let tableDataByClerk = []
            //         for (let item of this.tableData) {
            //
            //             if (item.Child.length > 0) {
            //
            //                 for (let childItem of item.Child) {
            //
            //                     childItem.area = item.area
            //                     childItem.province = item.province
            //                     childItem.city = item.city
            //                     childItem.name = item.name
            //
            //                     tableDataByClerk.push(childItem)
            //                 }
            //             }
            //         }
            //
            //
            //         import('@/vendor/Export2Excel').then(excel => {
            //             const tHeader = ['区域', '省份', '城市', '门店', '店员', '排班工时', '迟到早退', '缺勤时长', '请假(扣薪)', '带薪休假', '加班工时', '三薪工时', '实际工时']
            //             const filterVal = ['area', 'province', 'city', 'name', 'last_name', 'shift_hours', 'c_lateleave', 'absence_hours', 'leave_hours', 'paid_leave_hours', 'ot_hours', 'legal_vacation_hours', 'paid_hours']
            //             const list = tableDataByClerk
            //             const data = this.formatJson(filterVal, list)
            //
            //             excel.export_json_to_excel({
            //                 header: tHeader,
            //                 data,
            //                 filename: '工时统计(人员汇总)',
            //                 autoWidth: this.autoWidth
            //             })
            //
            //         })
            //
            //
            //         this.loading = false
            //     } catch (err) {
            //         this.loading = false
            //         this.error()
            //     }
            // },
            // async handleExportDataByDay() {//每日明细
            //     try {
            //
            //         this.loading = true
            //         let data = {
            //             user_id: this.$store.getters.getUser.user_id,
            //             tenant_id: this.$store.getters.getUser.tenant_id,
            //             month: this.date.format("YYYY-MM"),
            //         }
            //
            //         await http.post('/wapi/v1/getWorkingHoursInfoByDay', data).then(res => {
            //
            //
            //             let tableData = res.data.schedule_array
            //
            //             import('@/vendor/Export2Excel').then(excel => {
            //                 const tHeader = ['区域', '省份', '城市', '门店', '日期', '排班工时', '迟到早退', '缺勤时长', '请假(扣薪)', '带薪休假', '加班工时', '三薪工时', '实际工时']
            //                 const filterVal = ['area', 'province', 'city', 'name', 'date', 'scheduling', 'lateleave', 'absence', 'leave', 'vacation', 'ot', 'legal', 'actual']
            //                 const list = tableData
            //                 const data = this.formatJson(filterVal, list)
            //
            //                 excel.export_json_to_excel({
            //                     header: tHeader,
            //                     data,
            //                     filename: '工时统计(每日明细)',
            //                     autoWidth: this.autoWidth
            //                 })
            //
            //             })
            //
            //
            //             this.loading = false
            //
            //
            //         })
            //     } catch (err) {
            //         this.loading = false
            //         this.error()
            //     }
            // },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            //单行点击事件
            cellClick(row, column, cell, event) {
                this.showModalMonth = true

                this.salesDetailByDay.storeName = row.store_name
                this.salesDetailByDay.tabPosition = 'day'
                this.salesDetailByDay.store_id = row.store_id

                this.getSalesDetailByDay()

            },
            //选择事件
            changeRadio(row) {

                if(row === 'day'){
                    this.getSalesDetailByDay()
                }else {
                    this.getSalesDetailByClerk()
                }
            },
            // 初始化页面获取数据
            async getSalesDetailByDay() {
                try {
                    this.loading = true

                    let data = {
                        store_id: this.salesDetailByDay.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        month: this.salesDetailByDay.dateByDay.format("YYYY-MM"),
                    }


                    await http.post('/wapi/v1/getSalesDetailByDay', data).then(res => {

                        let data = res.data

                        this.salesDetailByDay.resultInfo = data.resultInfo
                        this.salesDetailByDay.tableDayData = data.day_result

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 初始化页面获取数据
            async getSalesDetailByClerk() {
                try {
                    this.loading = true

                    let data = {
                        store_id: this.salesDetailByDay.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        month: this.salesDetailByDay.dateByDay.format("YYYY-MM"),
                    }


                    await http.post('/wapi/v1/getSalesDetailByClerk', data).then(res => {

                        let data = res.data

                        this.salesDetailByDay.tableCLerkData = data.result

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 关闭模态框
            closeModal() {
                this.showModalMonth = false
            },
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;

        .body {

            .wrap {
                display: flex;
                justify-content: space-between;
                flex-wrap: nowrap;

            }
            .font {
                margin: 0 10px;
                font-size: $fontSize;
                color: #3b3b3e;
                text-align: left;
            }

            .border {
                border-bottom: 2px dashed #e7eaec;
                padding: 10px 0px;
            }

            .month {
                margin-top: 20px;
                margin-left: 40%;
                margin-bottom: 10px;
            }
            .text {
                font-size: 13px;
                color: #4D586D;
            }

            .span {
                display: inline-block;
                font-size: 12px;
                color: #FFFFFF;
                text-align: left;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
                max-width: 64px;
            }
            .span_color {
                color: #ED3B3F;
            }

            .demo-table-expand {
                font-size: 0;
            }
            .demo-table-expand label {
                width: 90px;
                color: #99a9bf;
            }
            .demo-table-expand .el-form-item {
                margin-right: 0;
                margin-bottom: 0;
                width: 100%;
            }
        }
        .modal {
            .title {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px dotted #e7eaec;
                padding-bottom: 10px;
                > span {
                    color: #3998f7;
                    font-size: 16px;
                }

            }
            .num {
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none !important;
                    margin: 0;
                }
            }
            .text {
                font-size: 13px;
                color: #4D586D;
            }

            .span {
                display: inline-block;
                font-size: 12px;
                color: #FFFFFF;
                text-align: left;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
                max-width: 64px;
            }
            .grop {
                height: 30px;
                border: #FF9901
            }
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }

    .channel {
        border: solid 1px #87909A;
        padding-left: 10px;
        padding-right: 10px;
        margin-left: -50px;
        font-size: 12px;
        border-radius: 4px;
        min-height: 58px;
        vertical-align: middle;

        /*display: flex;*/
        /*justify-content: space-around;*/
        display: flex;
        align-items: center;
        position: relative;
    }

    .b_modal {
        color: #ffffff;
        display: flex;
        justify-content: space-around;
        position: relative;
    }

    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

</style>




// WEBPACK FOOTER //
// src/pages/report/salesStatistics/index.vue